import React, { useState } from 'react';

function Animation() {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div className="overflow-hidden flex w-full relative mt-20 max-md:hidden">
      <div className="z-[150] absolute left-0 top-0 flex justify-center items-center w-full">
        <div
          className="flex flex-col w-full justify-center items-center text-center max-sm:w-full font-extrabold text-white"
          style={{ marginTop: 'clamp(1rem, 2vw, 3rem)' }}
        >
          <span
            className="font-extrabold text-white"
            style={{
              fontSize: 'clamp(1.5rem, 4vw, 3rem)',
              lineHeight: 'clamp(2rem, 4.8vw, 4rem)',
            }}
          >
            Going beyond button
          </span>
          <span
            className="font-extrabold text-white"
            style={{
              fontSize: 'clamp(1.5rem, 4vw, 3rem)',
              lineHeight: 'clamp(2rem, 4.8vw, 4rem)',
            }}
          >
            and commands
          </span>
        </div>
      </div>
      {!isVideoLoaded && (
        <img
          src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723783456/pixa-pie/animation/animation_thumbnail.png"
          alt="video loading..."
          className="min-w-full h-full object-fill max-md:object-contain xxl:object-fill object-top"
        />
      )}
      <video
        className="min-w-full h-full object-contain xxl:object-fill object-top"
        autoPlay
        loop
        muted
        playsInline
        webkit-playsinline="true"
        crossOrigin="anonymous"
        onLoadedData={handleVideoLoaded}
        preload="metadata"
        src="https://res.cloudinary.com/dx6dieevo/video/upload/f_auto,q_auto:good,w_auto/v1723783457/pixa-pie/animation/animation.mov"
      ></video>
    </div>
  );
}

export default React.memo(Animation);
